module.exports = __webpack_public_path__ + "img/bg-header.bb68406d.png";